import {ShapeCommand} from '../commands.template';

export class ActivitySwapAttributeCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey: number;
  reverseData: any;

  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.activityMxKey);
    });
    const attribute = activityJson.attributes.find(
      att => Number(att.mxKey) === Number(this.object.mxKey)
    );

    this.reverseData = {
      activityMxKey: this.object.activityMxKey,
      mxKey: attribute.mxKey,
      position: this.object.oldPosition
    };

    return this;
  }

  public execute() {
    super.execute();
    const action = {
      changeAttribute: {
        activityMxKey: Number(this.object.activityMxKey),
        mxKey: this.object.mxKey,
        position: this.object.newPosition
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      changeAttribute: {
        activityMxKey: Number(this.object.activityMxKey),
        mxKey: this.reverseData.mxKey,
        position: this.reverseData.position
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  private redrawActivity(activityMxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(activityMxKey))
      .comp.instance.setupFromJson();
  }
}
